<template>
    <div class="inline-block">

        <div v-if="confirming" class="fixed z-10 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <!--
                  Background overlay, show/hide based on modal state.
            
                  Entering: "ease-out duration-300"
                    From: "opacity-0"
                    To: "opacity-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100"
                    To: "opacity-0"
                -->
                <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <!-- This element is to trick the browser into centering the modal contents. -->
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true"></span>&#8203;
                <!--
                  Modal panel, show/hide based on modal state.
            
                  Entering: "ease-out duration-300"
                    From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    To: "opacity-100 translate-y-0 sm:scale-100"
                  Leaving: "ease-in duration-200"
                    From: "opacity-100 translate-y-0 sm:scale-100"
                    To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                -->
                <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div class="sm:flex sm:items-start">
<!--                        <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">-->
<!--                            &lt;!&ndash; Heroicon name: exclamation &ndash;&gt;-->
<!--                            <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">-->
<!--                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />-->
<!--                            </svg>-->
<!--                        </div>-->
                        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                Are you sure?
                            </h3>
                            <div class="mt-2" v-if="message">
                                <p class="text-sm text-gray-500">
                                    {{ message }}
                                </p>
                                
                            </div>

                            <slot name="message"></slot>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-4 sm:ml-10 sm:pl-4 sm:flex">
                        <button @click="$emit('confirm'),confirming=false" type="button" :class="apply" class="w-full">
                            <template v-if="confirmtext">
                                {{ confirmtext }}
                            </template>
                            <template v-else>
                                Confirm <slot></slot>
                            </template>
                        </button>
                        <button @click="confirming=false" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
        
<!--        <div v-if="confirming" class="inline-block px-2 py-1 rounded shadow-inner">-->
<!--          <span @click="$emit('confirm'),confirming=false" class="cursor-pointer inline-flex items-center px-2 py-1 text-xs font-medium rounded-md text-white bg-indigo-600 transition duration-150 ease-in-out">-->
<!--              <template v-if="confirmtext">-->
<!--                  {{ confirmtext }}-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                Confirm <slot></slot>-->
<!--              </template>-->
<!--              </span>-->
<!--            <span @click="confirming=false" class="cursor-pointer inline-flex items-center px-2 py-1 text-xs font-medium rounded-md text-gray-700 bg-gray-200 transition duration-150 ease-in-out">-->
<!--                Cancel-->
<!--              </span>-->
<!--        </div>-->
        <span @click="confirming=true" :class="apply" class="cursor-pointer" v-else>
            <slot></slot>
        </span>
    </div>
</template>

<script>
export default {
  name: "ConfirmableButton",
    props: ['apply', 'confirmtext', 'message'],
    data() {
      return {
          confirming: false
      }
    }
}
</script>

<style scoped>

</style>
